import CryptoJS from 'crypto-js';

import { getSegmentWriteKey } from './getSegmentWriteKey';

export const getSegmentHeaders = () => {
  const writeKey = getSegmentWriteKey();

  if (writeKey) {
    const encodedWriteKey = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(writeKey));

    return {
      Authorization: `Basic ${encodedWriteKey}`,
      'Content-Type': 'application/json',
    };
  }
};
